import { JsonUtils } from '../../utils/json.util'
import { ActiveSearchState } from './active.search.by.state'

export class ActiveSearchSummary {

    private _total_forms: number | undefined
    private _promoted_total_forms: number | undefined
    private _rejected_total_forms: number | undefined
    private _pending_total_forms: number | undefined
    private _by_state: ActiveSearchState[] | undefined

    get total_forms(): number | undefined {
        return this._total_forms
    }
    set total_forms(value: number | undefined) {
        this._total_forms = value
    }
    get promoted_total_forms(): number | undefined {
        return this._promoted_total_forms
    }

    set promoted_total_forms(value: number | undefined) {
        this._promoted_total_forms = value
    }
    get rejected_total_forms(): number | undefined {
        return this._rejected_total_forms
    }
    set rejected_total_forms(value: number | undefined) {
        this._rejected_total_forms = value
    }

    get pending_total_forms(): number | undefined {
        return this._pending_total_forms
    }
    set pending_total_forms(value: number | undefined) {
        this._pending_total_forms = value
    }
    get by_state(): ActiveSearchState[] | undefined {
        return this._by_state
    }
    set by_state(value: ActiveSearchState[] | undefined) {
        this._by_state = value
    }

    public fromJSON(json: any): ActiveSearchSummary {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
       
        
        if (json.total_forms !== undefined) {
            this.total_forms = json.total_forms
        }
        if (json.promoted_total_forms !== undefined) {
            this.promoted_total_forms = json.promoted_total_forms
        }
        if (json.rejected_total_forms !== undefined) {
            this.rejected_total_forms = json.rejected_total_forms
        }
        if (json.pending_total_forms !== undefined) {
            this.pending_total_forms = json.pending_total_forms
        }
        if (json.by_state !== undefined) {
            this.by_state = json.by_state.map((item: ActiveSearchState)=>new ActiveSearchState().fromJSON(item))
        }
    
        return this
    }
    public toJSON(): any {
        return {
            total_forms: this.total_forms || 0,
            promoted_total_forms: this.promoted_total_forms || 0,
            rejected_total_forms: this.rejected_total_forms || 0,
            pending_total_forms: this.pending_total_forms || 0,
            by_state: this.by_state || 0
        }
    }
}